import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DateTimeInput,
  Edit,
  FormTab,
  FunctionField,
  List,
  NumberInput,
  SearchInput,
  TextField,
} from "react-admin";
import { useCommonLabels } from "../i18n/hooks";
import { FilePreviewLink } from "../ui/fileUpload";
import { FormSection } from "../ui/forms/FormSection";
import { BodyLangFields, TitleLangFields } from "../ui/forms/langFields";
import { LangTabbedForm } from "../ui/forms/LangTabbedForm";
import { LocalizedFileControls, LocalizedFileLangField } from "../ui/forms/LocalizedFileInput";
import { normalizeContentRecord } from "../ui/forms/normalizeMedia";
import CoverTextColorField from "../ui/forms/CoverTextColorField";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

const PhNewsForm = () => {
  const c = useCommonLabels();
  return (
    <LangTabbedForm>
      <FormTab label="Общее">
        <FormSection title="Публикация" subtitle="Порядок на главной, дата и статус">
          <NumberInput source="SortOrder" label="Порядок" defaultValue={0} fullWidth />
          <DateTimeInput source="PublishedAt" label="Дата публикации" fullWidth />
          <BooleanInput source="ShowOnHome" label="Показывать на главной" defaultValue />
          <BooleanInput source="Active" label={c.active} defaultValue />
        </FormSection>
        <FormSection title="Изображение">
          <LocalizedFileControls
            baseSource="Image"
            label={c.image}
            kind="image"
            helperText="JPG/PNG — загрузка через файловый сервис"
          />
          <CoverTextColorField />
        </FormSection>
      </FormTab>
      <FormTab label="🇦🇿 AZ">
        <TitleLangFields lang="AZ" titleRequired />
        <BodyLangFields lang="AZ" bodyRequired />
        <LocalizedFileLangField baseSource="Image" lang="AZ" label={c.image} kind="image" />
      </FormTab>
      <FormTab label="🇷🇺 RU">
        <TitleLangFields lang="RU" titleRequired />
        <BodyLangFields lang="RU" bodyRequired />
        <LocalizedFileLangField baseSource="Image" lang="RU" label={c.image} kind="image" />
      </FormTab>
      <FormTab label="🇬🇧 EN">
        <TitleLangFields lang="EN" titleRequired />
        <BodyLangFields lang="EN" bodyRequired />
        <LocalizedFileLangField baseSource="Image" lang="EN" label={c.image} kind="image" />
      </FormTab>
    </LangTabbedForm>
  );
};

export const PhNewsList = () => {
  const c = useCommonLabels();
  return (
    <List filters={filters} sort={{ field: "SortOrder", order: "DESC" }}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="Id" label="ID" />
        <TextField source="TitleRU" label="Заголовок" />
        <FunctionField
          label={c.image}
          render={(record: { Image?: string }) => <FilePreviewLink value={record.Image} />}
        />
        <BooleanField source="ShowOnHome" label="На главной" />
        <BooleanField source="Active" label={c.status} />
      </Datagrid>
    </List>
  );
};

export const PhNewsEdit = () => (
  <Edit mutationMode="pessimistic" transform={normalizeContentRecord}>
    <PhNewsForm />
  </Edit>
);

export const PhNewsCreate = () => (
  <Create transform={normalizeContentRecord}>
    <PhNewsForm />
  </Create>
);
